// eslint-disable-next-line
export const config = {
  // prefix for all route
  appPackage: "pawn_app",
  basename: process.env.REACT_APP_PREFIX || "",
  apiPrefix: "",
  appType: 'USER',
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  apiUrl: process.env.REACT_APP_BASEAPI,
  webviewUrl: process.env.REACT_APP_WEBVIEW_URL,
  homepageUrl: process.env.REACT_APP_HOMEPAGE_URL || "https://heycooker.com",
  version: process.env.REACT_APP_VERSION || '1.0.0',
  apiVersion: process.env.REACT_APP_API_VERSION || '1.0.0',
  debug: process.env.REACT_APP_DEBUG === "TRUE" || process.env.REACT_APP_DEBUG === true,
  s3Url: process.env.REACT_APP_AWS_BASE_URL,
  youtubeUrl: "https://www.youtube.com/watch?v=",
  buildId: "20230929001",
  appStorage: process.env.REACT_APP_STORAGE || "session",
  webviewVersion: process.env.REACT_APP_WEBVIEW_VERSION || "1.0.0",
  fixedLoc: process.env.REACT_APP_FIXED_LOC || 'VN',
  fixedLang: process.env.REACT_APP_FIXED_LANG || 'vi',
  // mqtt realtime
  mqttBrokerUrl: process.env.REACT_APP_MQTT_BROKER || "ws://13.251.176.34:8083/mqtt",
  mqttPrefix: process.env.REACT_APP_MQTT_PREFIX || "dev/",
  apiKeyMap: process.env.REACT_APP_KEY_MAP || 'AIzaSyAJiVEqAjyvjSZXdk1gIJABatSJWP5zR6o',
  appLat: 16.072180426953476, 
  appLng: 108.21637740991183, 
  addressDefault: 'Đà Nẵng', 
  enableAdmob: process.env.REACT_APP_ENABLE_ADMOB === "TRUE" || process.env.REACT_APP_ENABLE_ADMOB === true,
}
